import { AppIcon, variantProvider } from '@/app'
import { Icon, Text, View } from '@/components'
import { CSSProperties } from 'react'
import { motion } from 'framer-motion'

type ActionButtonProps = {
  onPress: () => void
  text?: string
  icon: AppIcon
  iconStyle?: CSSProperties
  style?: CSSProperties
}

export const ActionButton = (props: ActionButtonProps) => {
  const { icon, onPress, text, iconStyle, style } = props

  return (
    <button onClick={onPress} style={{ ...styles.actionWrapper, ...style }}>
      <View variants={['alignCenter', 'column']}>
        <motion.div style={styles.animatedWrapper} whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.95 }}>
          <div style={styles.shadow} />
          <Icon
            debugName=""
            name={icon}
            style={{
              ...styles.actionIcon,
              ...iconStyle,
              position: 'relative'
            }}
          />
        </motion.div>

        {text ? <Text text={text} variants={['p4', 'color:neutral1']} /> : null}
      </View>
    </button>
  )
}

const styles = variantProvider.createComponentStyle(
  theme => ({
    actionIcon: {
      height: 32,
      width: 32,
      color: theme.colors.neutral1
    },
    actionWrapper: {
      border: 'none',
      background: 'transparent',
      cursor: 'pointer',
      borderRadius: theme.borderRadius.rounded,
      padding: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      position: 'relative',
      overflow: 'visible'
    },
    animatedWrapper: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 32,
      height: 32
    },
    shadow: {
      position: 'absolute',
      bottom: -0,
      right: -0,
      height: 24,
      width: 24,
      borderRadius: '50%',
      backgroundColor: 'rgba(0,0,0,0.2)',
      filter: 'blur(4px)',
      zIndex: 0,
      transform: 'translateZ(0)'
    }
  }),
  true
)
